import React, { Component } from 'react';
import './css/site.css';
import './css/foundation.css';

export class NavMenu extends Component {
    static displayName = NavMenu.name;

    render() {
        return (
            <header>
                <div className="grid-container">
                    <div className="grid-x">
                        <div className="m-header-content m-header-entry nobottomborder">
                            <div className="nav-insert">
                                <a href="/" className="a-logo logo-as-background"></a>
                            </div>
                            <div className="left-padding">
                                <h3>Carle Health Physician Partners Administration</h3>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
        );
    }
}